import React, {useState} from 'react';
import { BetsForm } from '../betsForm/default';
import { getBetsInfo } from '../../utils/betsFields';

const Bets = () => {
  const [betsIndex, setbetsIndex] = useState(0);
  const bets = getBetsInfo();

  return (<div className="container mt-4">

    <h4 className="display-4 text-center mb-4">
      <i className="fas fa-clipboard-list"></i> Formularios de loterías
    </h4>
    <div className="nav-wrapper">
      <ul className="nav nav-tabs">
        {bets.map((bet, index) => (
          <li className="nav-item" key={index}>
            <button
              className={`nav-link ${betsIndex === index ? 'active' : ''}`}
              onClick={() => setbetsIndex(index)}
            >
              {bet.name}
            </button>
          </li>
        ))}
      </ul>
    </div>
    <BetsForm formNumber={betsIndex} />
  </div>)
};

export default Bets;